import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, List, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { ExpandMore, PeopleAlt, LocalTaxi, AdminPanelSettings } from '@mui/icons-material';
import { SectionHeader, TodoBanner, Done, Todo } from './DocPrimitives';
import { RIDER_STEPS_DONE, RIDER_STEPS_TODO, DRIVER_STEPS_DONE, DRIVER_STEPS_TODO, ADMIN_PORTAL_PAGES } from '../../data/docs/userGuides';

export default function UserGuidesTab() {
  return (
    <Box>
      <SectionHeader icon={<PeopleAlt />} title="User Guides" subtitle="Operational guides for riders, drivers, and admin portal users" />

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Box display="flex" alignItems="center" gap={1}>
            <LocalTaxi fontSize="small" />
            <Typography fontWeight={600}>Rider Guide</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <TodoBanner message="Full illustrated rider guide pending. The flow below reflects the implemented app behaviour." />
          <List dense disablePadding>
            {RIDER_STEPS_DONE.map((item, i) => <Done key={i}>{item}</Done>)}
            {RIDER_STEPS_TODO.map((item, i) => <Todo key={i}>{item}</Todo>)}
          </List>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Box display="flex" alignItems="center" gap={1}>
            <AdminPanelSettings fontSize="small" />
            <Typography fontWeight={600}>Driver Guide</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <TodoBanner message="Full illustrated driver guide pending. The flow below reflects the implemented app behaviour." />
          <List dense disablePadding>
            {DRIVER_STEPS_DONE.map((item, i) => <Done key={i}>{item}</Done>)}
            {DRIVER_STEPS_TODO.map((item, i) => <Todo key={i}>{item}</Todo>)}
          </List>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Box display="flex" alignItems="center" gap={1}>
            <AdminPanelSettings fontSize="small" />
            <Typography fontWeight={600}>Admin Portal Guide</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell><strong>Page</strong></TableCell>
                <TableCell><strong>What you can do</strong></TableCell>
                <TableCell><strong>Who can access</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ADMIN_PORTAL_PAGES.map(({ page, what, who }) => (
                <TableRow key={page}>
                  <TableCell><strong>{page}</strong></TableCell>
                  <TableCell><Typography variant="caption">{what}</Typography></TableCell>
                  <TableCell><Typography variant="caption" color="text.secondary">{who}</Typography></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
